import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  ContentSectionBlock
} from 'camino-react'

import Attachments from 'Components/Attachments'
import TicketCorrespondenceForm from 'Components/Tickets/Correspondence/Form'
import TicketCorrespondenceLog from 'Components/Tickets/Correspondence/Log'

class TicketClientCorrespondence extends React.Component {
  constructor (props) {
    super(props)

    const { comments } = props

    this.state = {
      comments
    }

    this.addCommentToLog = this.addCommentToLog.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    const { comments } = this.state

    if (nextProps.comments !== comments) {
      this.setState({ comments: nextProps.comments })
    }
  }

  addCommentToLog (comment) {
    this.setState((prevState) => {
      const { comments } = prevState

      return { comments: [comment, ...comments] }
    })

    // Page reload in case ticket was on hold (GWS)
    window.location.reload()
  }

  render () {
    const {
      ticket,
      attachmentAdmin,
      user_token: userToken,
      loading,
      current_user
    } = this.props
    const { comments } = this.state

    return (
      <Card padding="none">
        <ContentSectionBlock title="Add correspondence">
          <TicketCorrespondenceForm
            currentUser={current_user}
            ticket={ticket}
            user_token={userToken}
            addCommentToLog={this.addCommentToLog}
            communication_type="correspondence"
            ticket_id={ticket.id}
          />
          <Attachments
            object={ticket}
            admin={attachmentAdmin}
            user_token={userToken}
          />
        </ContentSectionBlock>

        <ContentSectionBlock title="Correspondence">
          <TicketCorrespondenceLog comments={comments} loading={loading} />
        </ContentSectionBlock>
      </Card>
    )
  }
}

TicketClientCorrespondence.propTypes = {
  comments: PropTypes.array
}

export default TicketClientCorrespondence
